import { processPods, strapiFetch } from '@/services/strapiService';

export const GetTermsOfService = async ({
    language,
    documentId = '',
}: {
    language: string;
    // documentId replaces the v4 numeric id. v5's findOne route is
    // `/terms-of-services/:documentId` — passing a numeric id 404s.
    documentId?: string;
}) => {
    if (documentId === '') {
        return await strapiFetch(`/terms-of-services`, language);
    }

    const response = await strapiFetch(`/terms-of-services/${documentId}`, language);

    const body = response.body_content ? await processPods(response.body_content) : null;

    const returnValue = {
        title: response?.title || '',
        description: response?.description || '',
        published_date: response?.published_date || '',
        body,
    };

    return returnValue;
};
